import { Component, ContentChild, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Table, TableService } from 'primeng/table';
import { TableConfig } from '../../../models/table/table-config.model';
import { TableDataSource } from '../../../models/table/table-data-source.interface';

export function tableFactory<T>(tableComponent: TableComponent<T>) {
    return tableComponent.primengTable;
}

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    providers: [
        TableService,
        {
            provide: Table,
            useFactory: tableFactory,
            deps: [TableComponent]
        }
    ]
})
export class TableComponent<T> implements OnInit {
    @Input() tableConfig!: TableConfig<T>;
    @Input() tableDataSource!: TableDataSource<T>;

    // eslint-disable-next-line
    @Input() toolBarTemplate: TemplateRef<any> | undefined;
    // eslint-disable-next-line
    @ContentChild('header', { static: false }) public headerTemplate: TemplateRef<any> | undefined;
    // eslint-disable-next-line
    @ContentChild('body', { static: false }) public bodyTemplate: TemplateRef<any> | undefined;
    @ViewChild('primengTable', { static: true }) public primengTable: Table | undefined;

    ngOnInit() {
        this.tableDataSource!.setGlobalFilter = this.setGlobalFilter;
        this.tableDataSource!.clearGlobalFilterField = this.clearGlobalFilter;
    }

    setGlobalFilter = (value: string) => {
        this.primengTable!.filterGlobal(value, 'contains');
    };

    clearGlobalFilter = (globalFilterInput: HTMLInputElement) => {
        globalFilterInput.value = '';
        this.primengTable!.clear();
    };
}
